module.exports = __webpack_public_path__ + "plus/img/e5643b9cdb2a41201e8a085fe0abac29.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/personal-red.png
// module id = px+c
// module chunks = 6